import React from "react";
import ButtonIcon from "Components/buttonIcon/ButtonIcon";
import s from "./toolbar.scss";

const EditorToolbarButton = (props) => {
  return (
    <ButtonIcon
      className={s.tbButton}
      icon={props.icon}
      onClick={props.onClick}
      data={props.data}
      active={props.active}
      {...props}
      square
    />
  );
};

EditorToolbarButton.displayName = "EditorToolbarButton";

export default EditorToolbarButton;
